document.querySelector('.js-header-menu').addEventListener('click', () => {
  document.body.classList.toggle('open-menu')
})

document.querySelectorAll('.js-header-nav a[href^="#"]').forEach((link) => {
  link.addEventListener('click', () => {
    document.body.classList.remove('open-menu')
  })
})
